import { render } from "./ContactInfo.vue?vue&type=template&id=c595b8cc&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"

import "./ContactInfo.vue?vue&type=style&index=0&id=c595b8cc&scoped=true&lang=css"
import "./ContactInfo.vue?vue&type=style&index=1&id=c595b8cc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c595b8cc"]])

export default __exports__